<template lang="pug">
    div.feed(@click="navigateToPage")
        div.feedImageWrapper
            div.feedImage(v-if="item.poster" :style="{ backgroundImage: `url('${item.poster}')` }")

            div.feedBadges

                // Type
                status-component.feedType(
                    v-if="type"
                    :class="`feedType${item.mode}`"
                ) {{ type }}

            div.feedItemDuration(v-if="item.duration")
                div {{ item.duration | timeCode }}

        div.feedContent {{ text }}
</template>

<script>
    import VueTypes from 'vue-types';
    import Status from '~components/Status';
    import timeCode from '~filters/timeCode';

    export default {
        components: {
            StatusComponent: Status
        },
        filters: {
            timeCode
        },
        props: {
            item: VueTypes.object.def({})
        },
        computed: {
            text() {
                if (this.item.feedLabel) return this.item.feedLabel;
                return this.item.mode === 'minute'
                    ? 'A new daily moment of inspiration'
                    : `Try this practice "${this.item.title}"${
                          this.item.instructor.fullName
                              ? ` with ${this.item.instructor.fullName}`
                              : ''
                      }`;
            },
            /**
             * Cover Image.
             * @returns {string}
             */
            coverImage() {
                if (this.item.poster) return this.item.poster;
                return `https://s3.us-east-2.amazonaws.com/chillanywhere.com/meditations-cover-images/buildingImage.png`;
            },

            type() {
                const types = this.$t('feed.type');
                return types[this.item.mode] ?? '';
            }
        },
        methods: {
            navigateToPage() {
                this.$router.push({
                    name:
                        this.item.mode === 'minute'
                            ? 'dashboard.mindfulMinutesItem'
                            : 'dashboard.sessions.view',
                    params: { id: this.item.id }
                });
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../../../assets/style/_mixins.styl";
    @import "../../../../assets/style/_variables.styl";

    .feed
        background: linear-gradient(90deg, rgba(255,255,255, 0.2) 0%, transparent 100%);
        border-radius: 10px
        margin: 8px 0
        display: flex
        align-items: center
        &:hover
            cursor: pointer
            background: linear-gradient(90deg, rgba(255,255,255, 0.22) 0%, transparent 100%);

            .feedImage
                transform:  scale(1.05)

    .feedImage
        padding: 8px
        width: 220px
        height: 175px
        background-size: cover
        background-position: center center
        border-radius: 10px
        transition:  transform 0.2s

    .feedContent
        padding: 16px
        text-align: center
        display: flex
        flex: 1 1 auto
        font-size: 22px
        font-weight: 300

    .feedType
        width: auto

        &minute
            background: linear-gradient(90deg, #7096D2 0%, transparent 100%);

        &meditation
            background: linear-gradient(90deg, rgba(#022341, 0.5) 0%, transparent 100%);


    .feedBadges
    .feedItemDuration
        position: absolute
        left: 8px

    .feedBadges
        top: 8px


    .feedItemDuration
        bottom: 8px
        font-size: 12px
        padding: 3px 2px
        border-radius: 10px
        background: linear-gradient(90deg, rgba(#022341, 0.5) 0%, transparent 100%);

    .feedImageWrapper
        position: relative

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .feed
            margin: 4px 0
        .feedImage
            width: 140px
            height: 95px
        .feedContent
            font-size: 13px
            line-height: 18px
            padding: 8px 12px
</style>
